import { NodePanelProps, PanelContainer } from "../../lib/panel/panel-container";
import { TriggerNodeData } from "../node-types";
import { PanelTriggerType } from "./panel-trigger-type";
import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { PanelOrderNotFulfilled } from "./panel-order-not-fulfilled";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";


export function TriggerNodePanel(props: NodePanelProps<TriggerNodeData>) {
  const form = useWorkflowForm();
  // Cast to string to handle extended trigger types not yet in API client
  const triggerType = form.watch("workflow.trigger.data.triggerType") as string;

  // The trigger identity (type + the status/event picked at creation) is
  // locked. Only genuinely tunable parameters stay editable — currently just
  // the "days since creation" threshold for order_not_fulfilled.
  return (
    <PanelContainer nodeProps={props}>
      <PanelTriggerType />
      {triggerType === "order_not_fulfilled" && (
        <>
          <FloatingPanelSeparator />
          <PanelOrderNotFulfilled />
        </>
      )}
    </PanelContainer>
  );
}
